import {PaymentLink} from "./paymentLinks";

export class Reservation {
    _id: string;
    orgUuid: string;
    name: string;
    tableLock: boolean;
    assignedEmployeeIds: string[];
    assignedEmployeeUsernames: string[];
    createdEmployeeId:string;
    orderIds: string[];
    note: string;
    tableName: string;
    tableNames: string[];
    paymentLinks: PaymentLink[];
    tableId: string;
    tableIds: string[];
    time: number;
    createdDate: number;
}
